import React from 'react';

const SmsCenterIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width="73"
    height="48"
    viewBox="0 0 73 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      d="M24.3838 5.52077L13.0249 9.35463C10.7532 10.1827 9.23859 12.3648 9.23859 14.8096V33.4758C9.23859 35.7882 10.8043 37.799 13.0249 38.3387L24.3838 42.4792L28.1701 48H13.3555C10.6649 48 8.02813 47.2362 5.74464 45.7953L5.38982 45.5714C4.47683 44.9953 3.64864 44.2916 2.92974 43.4813C1.04345 41.3551 0 38.5979 0 35.7398V12.9056C0 10.5827 0.627994 8.30404 1.8159 6.31677C2.90989 4.48659 4.45312 2.95869 6.28156 1.88682C8.21084 0.75584 10.4125 0.153355 12.6418 0.153355H28.1701L24.3838 5.52077Z"
      fill="#FE6B05"
    />
    <path
      d="M48.6162 5.36741L59.9751 9.20128C62.2468 10.0294 63.7614 12.2114 63.7614 14.6562V33.3224C63.7614 35.6348 62.1957 37.6457 59.9751 38.1853L48.6162 42.3259L44.8299 47.8466H59.6445C62.3351 47.8466 64.9719 47.0828 67.2554 45.6419L67.6102 45.418C68.5232 44.8419 69.3514 44.1383 70.0703 43.3279C71.9566 41.2017 73 38.4445 73 35.5864V12.7523C73 10.4293 72.372 8.15069 71.1841 6.16341C70.0901 4.33324 68.5469 2.80534 66.7184 1.73347C64.7892 0.602485 62.5875 0 60.3582 0H44.8299L48.6162 5.36741Z"
      fill="#FE6B05"
    />
    <path d="M48.6162 21.0096H24.3838V26.8371H48.6162V21.0096Z" fill="#FE6B05" />
  </svg>
);

export default SmsCenterIcon;
